import { render, staticRenderFns } from "./HomeInventory.vue?vue&type=template&id=13ca417b&scoped=true"
import script from "./HomeInventory.vue?vue&type=script&lang=js"
export * from "./HomeInventory.vue?vue&type=script&lang=js"
import style0 from "./HomeInventory.vue?vue&type=style&index=0&id=13ca417b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca417b",
  null
  
)

export default component.exports